import { AuthenticationScheme } from '@see-power-pft-common-js/auth/enums';
import { HTTP_STATUS } from 'common-react/constants/http-status';

export const getDevSchemeAuthenticationJwtToken = async () => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_PLUTO_API_ENDPOINT}/authentication/token`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          scheme: AuthenticationScheme.DEV,
          'auth-code': import.meta.env.VITE_DEV_EMAIL,
        }),
      },
    );
    if (response.status === HTTP_STATUS.UNAUTHORIZED) {
      return;
    }
    if (response.ok) {
      return await response.text();
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);

    return;
  }
};
